var inViewport = {

  init: function () {
    $('.js-in-viewport').each(function(i) {
      if ((($(window).outerHeight() >= $(this).offset().top) || ($(window).outerHeight() + $(window).scrollTop()) >= $(this).offset().top)) {
        $(this).delay(i * 150).queue(function(next) {
          $(this).addClass('in-viewport');

          next();
        });
      }
    });

    $(window).on('scroll', function() {
      $('.js-in-viewport:in-viewport( -50 ):not(".in-viewport")').each(function() {
        $(this).addClass('in-viewport');
      });
    });
  },
};

export default inViewport;



// WEBPACK FOOTER //
// ./scripts/modules/is-in-viewport.js